function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchArrow = function SvgSearchArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m2 9.7 6 4.8m0 0 6-4.8m-6 4.787V2.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round",
    style: {
      fill: "currentColor",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      stroke: "currentColor",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M7.374 15.274c.241.21.46.322.65.333.245-.032.429-.174.601-.331l-.635-.94z"
  }));
};
export default SvgSearchArrow;